import { useState, useEffect } from 'react';

export type FontSize = 'sm' | 'md' | 'lg' | 'xl';

const STORAGE_KEY = 'winclap_font_size';

const FONT_SIZE_PX: Record<FontSize, number> = {
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
};

function applyFontSize(size: FontSize) {
  document.documentElement.style.fontSize = `${FONT_SIZE_PX[size]}px`;
}

export function useAccessibilitySettings() {
  const [fontSize, setFontSizeState] = useState<FontSize>(() => {
    const stored = localStorage.getItem(STORAGE_KEY) as FontSize | null;
    return stored && FONT_SIZE_PX[stored] ? stored : 'md';
  });

  useEffect(() => {
    applyFontSize(fontSize);
  }, [fontSize]);

  function setFontSize(size: FontSize) {
    setFontSizeState(size);
    localStorage.setItem(STORAGE_KEY, size);
    applyFontSize(size);
  }

  return { fontSize, setFontSize, FONT_SIZE_PX };
}

// Apply on first load before React mounts (avoids flash)
export function initAccessibilitySettings() {
  const stored = localStorage.getItem(STORAGE_KEY) as FontSize | null;
  if (stored && FONT_SIZE_PX[stored]) {
    document.documentElement.style.fontSize = `${FONT_SIZE_PX[stored]}px`;
  }
}
